import React, { Fragment } from 'react';

const CommunitySafe = () => (
  <Fragment>
    <ul>
      <li>Wash and sanitize your hands frequently.</li>
      <li>
        Bring disinfectant wipes to clean the vehicle before and after use.
        Cleaning wipes are also available at the lot.
      </li>
      <li>
        To be cautious, wear a mask while driving and keep windows open for
        ventilation at your discretion.
      </li>
      <li>
        If you're feeling unwell or showing symptoms, please cancel your
        booking and stay home.
      </li>
      <li>
        If you become sick after your booking, let us know so we can
        isolate the vehicle and ensure it's thoroughly cleaned before
        rebooking.
      </li>
    </ul>
  </Fragment>
);

export default CommunitySafe;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/SafetySupport/CommunitySafe.js